import { moduleProviderFactory } from 'core/providers';
import { ESignPreferenceEdit, ESignPreferenceList } from 'application/esign-preference/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.esign-preference',
                pattern: '/esign-preference',
                children: [
                    {
                        name: 'master.app.main.esign-preference.list',
                        pattern: '',
                        tabTitle: 'ESIGN_PREFERENCE.LIST.TITLE_SECONDARY',
                        component: ESignPreferenceList,
                        data: {
                            title: 'ESIGN_PREFERENCE.LIST.TITLE_SECONDARY'
                        }
                    },
                   {
                        name: 'master.app.main.esign-preference.create',
                        pattern: '/create',
                        tabTitle: 'Create Eligibility Status',
                        component: ESignPreferenceEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'ESIGN_PREFERENCE.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.esign-preference.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit E-Sign Preference',
                        component: ESignPreferenceEdit,
                        authorization: 'portalSection.update',
                        data: {
                            title: 'ESIGN_PREFERENCE.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.ESIGN_PREFERENCES_SUB',
                        route: 'master.app.main.esign-preference.list',
                        order: 4,
                    }                    
                ]
            }
        ]
    });
})();
